<template>
  <div class="bg-white rounded box-shadow my-1 p-3">
    <div class="row">
      <div
        v-if="show"
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br />
        </span>
      </div>
      <div class="col float-right">
        <b-button
          v-b-modal.tree-modal
          type="button"
          class="btn btn-success float-right btn-sm mb-1 text-black"
          @click="$bvModal.show('modal-lg-tree'), resetForm()"
        >
          Add tree
          <i class="fas fa-plus"></i>
        </b-button>
      </div>
    </div>

    <div class="scrollable-table">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Land Mouza</th>
            <th>Tree Name</th>
            <th>Large</th>
            <th>Medium</th>
            <th>Small</th>
            <th>Sapling</th>
            <th>No. Fruits</th>
            <th>Yearly Income</th>
            <th>LA Case</th>
            <th>CCL Amount</th>
            <th>Book/Sub Book</th>
            <th>Cheque No.</th>
            <th>Cheque Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr li v-for="(tree, index) in trees" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <b> Mouza: {{ tree.tree_mouza.desc }}</b>
            </td>
            <td>{{ tree.tree_name.desc }}</td>
            <td>{{ tree.tree_large }}</td>
            <td>{{ tree.tree_medium }}</td>
            <td>{{ tree.tree_small }}</td>
            <td>{{ tree.tree_saplings }}</td>
            <td>{{ tree.nos_fruits }}</td>
            <td>{{ tree.yearly_income }}</td>
            <td>{{ tree.la_case }}</td>
            <td>{{ tree.ccl_amount }}</td>
            <td>{{ tree.book_no }}/{{ tree.book_sub_no }}</td>
            <td>{{ tree.cheque_no }}</td>
            <td>{{ tree.cheque_date }}</td>
            <td>
              <b-button
                size="sm"
                variant="warning"
                class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                @click.prevent="edittreeodal(tree), $bvModal.show('modal-lg-tree')"
              >
                <i class="far fa-edit"></i>
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="btn btn-warning btn-xs waves-effect waves-light"
                @click.prevent="softDelete(tree.id)"
              >
                <i class="far fa-trash-alt"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <b-modal
        id="modal-lg-tree"
        size="lg"
        title="tree Information"
        hide-footer
      >
        <div class="modal-content bg-white rounded box-shadow">
          <div class="form-row">
            <div class="col">
              <label for="land_id" class="col-form-label col-form-label-sm"
                >Select Land</label
              >
              <select
                v-model="tree.land_id"
                v-validate="'required'"
                id="land_id"
                name="land_id"
                class="form-control form-control-sm"
                @change="landOwnership(tree.land_id)"
              >
                <option selected value="selected"
                  >Select Land Ownership Type</option
                >
                <option v-for="land in lands" v-bind:value="land.id"
                  >{{ land.id }} : {{ land.mouza.desc }} :
                  {{ land.land_type.desc }}</option
                >
              </select>
              <div class="invalid-feedback">Please Select Valid Land</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <label for="c_tree_name_id" class="col-form-label col-form-label-sm"
                >Tree Name</label
              >
              <select
                v-model="tree.c_tree_name_id"
                v-validate="'required'"
                id="c_tree_name_id"
                name="c_tree_name_id"
                class="form-control form-control-sm"
                @change="TreeIdToType(tree.c_tree_name_id)"
              >
                <option selected disabled>Select Tree Name</option>
                <option
                  v-for="tree_name in tree_names"
                  v-bind:value="tree_name.id"
                  >{{ tree_name.id }} : {{ tree_name.desc }}</option
                >
              </select>
              <div class="invalid-feedback">Please Select Tree Name</div>
            </div>
            <div class="col">
              <label for="tree_type" class="col-form-label col-form-label-sm"
                >Tree Type</label
              >
              <select
                v-model="tree.c_tree_type_id"
                id="tree_type" name="tree_type"
                class="form-control form-control-sm"
                disabled>
                <option selected disabled>Select Tree Type</option>
                <option
                  v-for="tree_type in tree_types"
                  v-bind:value="tree_type.id"
                  >{{ tree_type.id }} : {{ tree_type.desc }}</option
                >
              </select>
              <div class="invalid-feedback">
                Please Select Valid Tree Type
              </div>
            </div>
            <div class="col">
              <label for="tree_large" class="col-form-label col-form-label-sm"
                >Number of Large Trees</label
              >
              <input
                type="number"
                v-model="tree.tree_large"
                id="tree_large" name="tree_large"
                class="form-control form-control-sm"
                placeholder="Number of Large Trees"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <label for="tree_medium" class="col-form-label col-form-label-sm"
                >Number of Medium Trees</label
              >
              <input
                type="number"
                v-model="tree.tree_medium"
                id="tree_medium" name="tree_medium"
                class="form-control form-control-sm"
                placeholder="Number of Medium Trees"
              />
            </div>
            <div class="col">
              <label for="tree_small" class="col-form-label col-form-label-sm"
                >Number of Small Trees</label
              >
              <input
                type="number"
                v-model="tree.tree_small"
                id="tree_small" name="tree_small"
                class="form-control form-control-sm"
                placeholder="Number of Small Trees"
              />
            </div>
            <div class="col">
              <label
                for="tree_saplings"
                class="col-form-label col-form-label-sm"
                >Number of Sapling</label
              >
              <input
                type="number"
                v-model="tree.tree_saplings"
                id="tree_saplings" name="tree_saplings"
                class="form-control form-control-sm"
                placeholder="Number of Sapling"
              />
            </div>
          </div>

          <div class="form-row pb-3">
            <div class="col-4">
              <label for="nos_fruits" class="col-form-label col-form-label-sm"
                >Number of Fruits</label
              >
              <input
                type="number"
                v-model="tree.nos_fruits"
                id="nos_fruits" name="nos_fruits"
                class="form-control form-control-sm"
                placeholder="Number of Fruits"
              />
            </div>
            <div class="col-4">
              <label
                for="yearly_income"
                class="col-form-label col-form-label-sm"
                >Yearly Income</label
              >
              <input
                type="number"
                v-model="tree.yearly_income"
                id="yearly_income" name="yearly_income"
                class="form-control form-control-sm"
                placeholder="Yearly Income"
              />
            </div>
          </div>
          <div v-if="!cclShow">
            <h6 class="modal-sub-header">CCL Information</h6>
            <div class="form-row">
              <div class="col">
                <label for="la_case" class="col-form-label col-form-label-sm"
                  >LA CASE</label
                >
                <input
                  type="text"
                  v-model="tree.la_case"
                  id="la_case" name="la_case"
                  class="form-control form-control-sm"
                  placeholder="LA Case"
                />
              </div>
              <div class="col">
                <label for="ccl_amount" class="col-form-label col-form-label-sm"
                  >CCL Amount</label
                >
                <input
                  type="number"
                  v-model="tree.ccl_amount"
                  id="ccl_amount" name="ccl_amount"
                  class="form-control form-control-sm"
                  placeholder="CCL Amount"
                />
                <div class="invalid-feedback">
                  Please provide Valid CCL Amount
                </div>
              </div>
              <div class="col">
                <label for="book_no" class="col-form-label col-form-label-sm"
                  >Award Book No.</label
                >
                <input
                  type="text"
                  v-model="tree.book_no"
                  id="book_no" name="book_no"
                  placeholder="Award book No."
                  class="form-control form-control-sm"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <label
                  for="book_sub_no"
                  class="col-form-label col-form-label-sm"
                  >Award Book Sub Serial</label
                >
                <input
                  type="text"
                  v-model="tree.book_sub_no"
                  id="book_sub_no" name="book_sub_no"
                  class="form-control form-control-sm"
                  placeholder="Award Book Sub serial"
                />
              </div>
              <div class="col">
                <label for="cheque_no" class="col-form-label col-form-label-sm"
                  >LA Cheque No.</label
                >
                <input
                  type="text"
                  v-model="tree.cheque_no"
                  id="cheque_no" name="cheque_no"
                  class="form-control form-control-sm"
                  placeholder="DC LA Cheque No."
                />
              </div>
              <div class="col">
                <label for="cheque_date" class="col-form-label col-form-label-sm"
                  >Cheque Date</label
                >
                <datepicker
                  v-model="tree.cheque_date"
                  id="cheque_date" name="cheque_date"
                  :input-class="'form-control form-control-sm'"
                ></datepicker>
              </div>
            </div>
          </div>

          <div class="form-row mt-3 mb-3">
            <div class="float-right">
              <b-button
                variant="success"
                v-if="!this.btn_edit"
                class="form-control-sm mr-2"  @click.prevent="save"
                >Add tree</b-button
              >
              <b-button
                variant="warning"
                v-if="this.btn_edit"
                class="form-control-sm mr-2" @click.prevent="update"
                >Update</b-button
              >
              <b-button
                size="sm"
                variant="danger"
                class="form-control-sm"
                @click="$bvModal.hide('modal-lg-tree')"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config";
import http from "@state/http";

export default {
  name: "tree-component",
  props: [],
  page: {
    title: "Fill up SES Form/tree",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Datepicker, Multiselect },
  data() {
    return {
      title: "tree Information",
      items: [
        {
          text: "Socio Economic Survey",
          href: "/ses/tree/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      success: false,
      dataMsg: false,
      failed: false,
      recordId: null,
      trees: [],
      tree_names: [],
      tree_types: [],
      lands: [],
      tree: {
        land_id: "",
        c_tree_name_id: "",
        tree_large: "",
        tree_medium: "",
        tree_small: "",
        tree_saplings: "",
        nos_fruits: "",
        yearly_income: "",
        la_case: "",
        ccl_amount: "",
        book_no: "",
        book_sub_no: "",
        cheque_no: "",
        cheque_date: "",
        ses_id: ""
      },
      cclShow: true,
      modalTitle: "",
      c_tree_type_id: "",
      btn_edit: false,
      validation_errors: {},
      tree_id: false,
      landChk: false,
      show: false
    };
  },

  methods: {
    landOwnership(LandId) {
      let obj = this.lands;
      let landChk = null;
      Object.keys(obj).forEach(function(key) {
        let ObjlandId = (key, obj[key])["id"];
        if (ObjlandId === LandId) {
          landChk = (key, obj[key])["c_land_ownership_id"];
          return;
        }
      });
      if (landChk !== 1) {
        this.cclShow = true;
      } else {
        this.cclShow = false;
      }
      this.landChk = landChk;
    },
    TreeIdToType(DesId) {
      this.c_tree_type_id = this.tree_names[DesId].c_tree_type_id;
    },
    resetForm() {
      this.btn_edit = false;
      this.tree = {};
      this.tree.ses_id = this.$route.params.ses_id;
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/ses/tree/store", this.tree)
            .then(response => {
              if (!response.data.error) {
                this.getPersonTrees();
                this.tree = {};
                this.tree.ses_id = this.$route.params.ses_id;
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    edittreeodal(tree) {
      this.btn_edit = true;
      this.tree = tree;
      this.tree_id = tree.id;
      this.landOwnership(tree.land_id);
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/ses/tree/update/" + this.tree_id, this.tree)
            .then(response => {
              if (!response.data.error) {
              }
              this.getPersonTrees();
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    softDelete(struId) {
      http.post("api/ses/tree/softDelete/" + struId).then(response => {
        if (!response.error) {
          this.getPersonTrees();
        }
      });
    },
    getCodes() {
      http.get("api/ses/tree/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.tree_names = data.tree_names;
          this.tree_types = data.tree_types;
        }
      });
    },
    getPersonTrees() {
      http
        .post("api/ses/tree/personTrees/" + this.tree.ses_id)
        .then(response => {
          if (!response.error) {
            this.trees = response.data.tree;
          }
        });
    },
    getPersonLands() {
      http
        .get("api/ses/land/person-lands/" + this.tree.ses_id)
        .then(response => {
          if (!response.error) {
            this.lands = response.data.land;
          }
        });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },

  mounted() {
    this.tree.ses_id = this.$route.params.ses_id;
    this.getCodes();
    this.getPersonTrees();
    this.getPersonLands();
    // this.view();
  }
};
</script>
